import React, { useEffect, useState } from 'react';
import { getKbStatusBoard } from '../lib/api/kb-api';

// 값 표기: 매매/전세가격=억, 전세가율=%, 그 외(지수/전망)=숫자
const fmtValue = (key, v) => {
  if (v == null) return '-';
  const n = Number(v);
  if (key === 'sale_price' || key === 'lease_price') return `${n}억`;
  if (key === 'lease_ratio') return `${n}%`;
  return `${n}`;
};

// 변동 표기: +0.09% / -6.23p / 0.00%p ...
const fmtChange = (v, unit) => {
  if (v == null) return '';
  const n = Number(v);
  const sign = n > 0 ? '+' : (n < 0 ? '' : '');
  return `${sign}${n}${unit || ''}`;
};
const changeColor = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return '#94a3b8';
  return n > 0 ? '#e11d48' : '#2563eb';
};

// 월간 지표는 metricDate 월을 라벨 앞에 (예: "8월 매매전망지수")
const displayLabel = (row) => {
  if (row.metricGroup === 'monthly' && row.metricDate) {
    const m = Number(String(row.metricDate).slice(5, 7));
    if (Number.isFinite(m) && m > 0) return `${m}월 ${row.metricLabel}`;
  }
  return row.metricLabel;
};

export default function KbStatusBoardStrip() {
  const [rows, setRows] = useState([]);
  const [baseDate, setBaseDate] = useState('');

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getKbStatusBoard();
        const items = Array.isArray(res?.items) ? res.items : [];
        if (!alive) return;
        setRows(items);
        setBaseDate(items[0]?.baseDate || '');
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);

  if (!rows || rows.length === 0) return null;

  // metricKey 별 그룹 (순서 유지)
  const groups = [];
  const byKey = new Map();
  rows.forEach((r) => {
    if (!byKey.has(r.metricKey)) {
      const g = { key: r.metricKey, label: displayLabel(r), regions: [] };
      byKey.set(r.metricKey, g);
      groups.push(g);
    }
    byKey.get(r.metricKey).regions.push(r);
  });

  return (
    <div className="kb-status-board">
      <div className="kb-status-board-head">
        {baseDate && <span>{String(baseDate).replace(/-/g, '. ')} 기준</span>}
      </div>
      <div className="kb-status-board-grid">
        {groups.map((g) => (
          <div key={g.key} className="kb-sb-col">
            <div className="kb-sb-label">{g.label}</div>
            {g.regions.map((r) => (
              <div key={r.regionCode} className="kb-sb-row">
                <span className="kb-sb-region">{r.regionName}</span>
                <span className="kb-sb-value">{fmtValue(r.metricKey, r.value)}</span>
                <span className="kb-sb-change" style={{ color: changeColor(r.changeValue) }}>
                  {fmtChange(r.changeValue, r.changeUnit)}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
